import { compose } from "recompose";

import { protectedComponentHoc } from "../../components/ProtectedComponent";
import { PolicyMappingsComponent } from "./component";

export const PolicyMappings = compose(protectedComponentHoc)(
  PolicyMappingsComponent
);
